import React from 'react';
import { useSectionView } from '../lib/pixel';
const testimonials = [{
  name: 'Laura P.',
  location: 'Buenos Aires',
  role: 'Nutricionista — Consultorio Privado',
  quote: 'Antes sentía que cada consulta era empezar de cero. Con el Megapack pude ordenar mis sesiones y trabajar con mucha más seguridad.'
}, {
  name: 'Martín C.',
  location: 'Rosario',
  role: 'Nutricionista Clínico',
  quote: 'Me ayudó a tener una estructura clara para la primera consulta y los seguimientos. Ahora sé qué revisar y cómo avanzar con cada paciente.'
}, {
  name: 'Sofía V.',
  location: 'Córdoba',
  role: 'Nutricionista Independiente',
  quote: 'Lo que más me sirvió fue dejar de improvisar. Tengo más orden, ahorro tiempo y siento que mi consulta se ve mucho más profesional.'
}];
export function Testimonials() {
  const sectionRef = useSectionView('Testimonials Section');
  return <section ref={sectionRef} className="w-full px-4 sm:px-6 lg:px-8 py-12 text-gray-900" style={{
    background: 'linear-gradient(180deg, rgb(240,253,244) 0%, rgb(187,247,208) 20%, rgb(167,243,208) 50%, rgb(187,247,208) 80%, rgb(240,253,244) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-210">
      <div className="mx-auto max-w-4xl" data-id="element-211">
        <h2 className="text-3xl sm:text-4xl font-black text-center text-gray-900 m-0 mb-3" data-id="element-212">
          Nutricionistas que ya dejaron de{' '}
          <span className="text-green-700" data-id="element-213">improvisar</span>
        </h2>

        <p className="text-center text-sm text-gray-600 font-medium m-0 mb-8" data-id="element-214">
          Más de 500 profesionales ya usan Nutrición Resuelta para organizar sus
          consultas, ahorrar tiempo y trabajar con más seguridad.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-215">
          {testimonials.map(t => <div key={t.name} className="bg-white rounded-2xl p-5 shadow-md border border-green-700/30" data-id="element-216">
              <div className="text-green-700 text-sm mb-3" data-id="element-217">⭐⭐⭐⭐⭐</div>

              <p className="text-sm text-gray-700 font-medium leading-6 m-0 mb-5" data-id="element-218">
                “{t.quote}”
              </p>

              <div data-id="element-219">
                <p className="text-sm font-black text-gray-900 m-0" data-id="element-220">
                  {t.name}
                </p>
                <p className="text-xs text-gray-500 m-0" data-id="element-221">
                  {t.role} · {t.location}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}